import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { Button, Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import DefaultError from 'ui/base/DefaultError';
import { deleteUser, usersSelector } from 'reducers/users';
import { connect } from 'react-redux';
import { RequestStateHelper } from 'reducers/createRequestReducer';
import AccountCancelMessage from 'containers/users/AccountCancelMessage';
import { LocaleConsumer } from 'containers/locale/LocaleProvider';
import { compose } from 'recompose';

const styles = {
    dialog: {
        width: '80%',
    },
};

function AccountCancelModal({
    classes,
    open,
    onRequestClose,
    user,
    cancel,
    error,
    isLoading
}) {

    return (
        <LocaleConsumer>
            {({ getTranslation }) => (
                <Dialog
                    onClose={onRequestClose}
                    open={open}
                    classes={{
                        paper: classes.dialog,
                    }}>
                    <DialogTitle>{getTranslation("user_account_cancel_title")}</DialogTitle>
                    <DialogContent>
                        <AccountCancelMessage />
                        {error && <DefaultError>{error}</DefaultError>}
                        <br />
                        <br />
                        <div style={{ display: 'flex' }}>
                            <Button 
                                style={{ marginLeft: 5, color: 'red' }} 
                                disabled={isLoading} 
                                onClick={() => cancel(user.id)}
                            >
                                {getTranslation("user_account_confirm_cancel")}
                            </Button>
                            <div style={{ flex: 1 }} />
                            <Button 
                                disabled={isLoading}
                                onClick={onRequestClose} 
                            >
                                {getTranslation("user_account_stop_cancel")}
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>
            )}
        </LocaleConsumer>
    );
}

export default compose(
    connect(
        (state) => ({
            user: usersSelector.getCurrentUser(state),
            isLoading: RequestStateHelper.isLoading(usersSelector.getUserDeleteSate(state)),
        }),
        (dispatch, ownProps) => ({
            cancel: (userId) => {
                return dispatch(deleteUser(userId)).then((response) => {
                    ownProps.onRequestClose();
                    return response;
                });
            },
        })
    ),
    withStyles(styles)
)(AccountCancelModal);